import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Paperclip, Trash2, Download, Reply, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadBlob } from "@/lib/vi";

// Fichiers scannés / joints d'un courrier du registre (lus par l'IA pour la réponse)
export function MailFiles({ mail, onChange }) {
  const ref = useRef();
  const upload = async (e) => {
    const files = [...(e.target.files || [])];
    e.target.value = "";
    for (const f of files) {
      const fd = new FormData(); fd.append("file", f);
      try { await api.post(`/registry/mails/${mail.id}/files`, fd); toast.success(`« ${f.name} » ajouté`); } catch (err) { toast.error(apiErr(err)); }
    }
    onChange();
  };
  const del = async (f) => { if (!window.confirm(`Retirer « ${f.nom} » ?`)) return; await api.delete(`/registry/mails/${mail.id}/files/${f.id}`); onChange(); };
  return (
    <div className="col-span-2 rounded-lg border p-2" data-testid="mail-files">
      <p className="text-xs font-semibold flex items-center gap-1 mb-1"><Paperclip className="h-3.5 w-3.5" />Fichiers du courrier ({(mail.files || []).length})</p>
      {(mail.files || []).map((f) => (
        <div key={f.id} className="flex items-center gap-1 text-xs border rounded px-2 py-1 mb-1">
          <span className="flex-1 truncate">{f.nom}</span>
          <button type="button" onClick={() => downloadBlob(`/registry/mails/${mail.id}/files/${f.id}`, f.nom)} className="p-1"><Download className="h-3.5 w-3.5" /></button>
          <button type="button" onClick={() => del(f)} className="p-1 hover:text-rose-600" data-testid={`mail-file-del-${f.id}`}><Trash2 className="h-3.5 w-3.5" /></button>
        </div>
      ))}
      <Button type="button" size="sm" variant="outline" onClick={() => ref.current?.click()} data-testid="mail-file-add"><Paperclip className="h-3.5 w-3.5 mr-1" />Ajouter (scan PDF, photo, DOCX…)</Button>
      <input ref={ref} type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx" className="hidden" onChange={upload} data-testid="mail-file-input" />
      <p className="text-[10px] text-slate-400 mt-1">L'assistant IA lit ces fichiers (PDF, images, DOCX) pour préparer la réponse.</p>
    </div>
  );
}

export function ReplyButton({ mail }) {
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    const t = toast.loading("Préparation de la réponse par l'assistant IA…");
    try {
      const r = await api.post(`/letters/reply-from/${mail.id}`);
      toast.success(r.data.ai_used ? `Réponse pré-rédigée${r.data.file_read ? " (fichier lu)" : ""} : ${r.data.reference}` : `Réponse créée : ${r.data.reference}`, { id: t });
      if (r.data.ai_error) toast.warning("L'IA n'a pas pu rédiger : modèle simple utilisé");
      nav(`/courriers/${r.data.id}/modifier`);
    } catch (e) { toast.error(apiErr(e), { id: t }); setBusy(false); }
  };
  return (
    <Button variant="ghost" size="sm" onClick={go} disabled={busy} title="Répondre" data-testid={`mail-reply-${mail.id}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Reply className="h-4 w-4 text-brand-700" />}<span className="hidden md:inline ml-1">Répondre</span>
    </Button>
  );
}
